import { FC } from "react";
import LoadingSpinner from "@app/shared/LoadingSpinner";
import { QESAlert } from "@app/shared/qes-standards/Alert";
import { getGenericErrorMessage } from "@app/shared/utility/getGenericErrorMessage";
import { QESWidget, QESWidgetContent, QESWidgetHeader, QESWidgetTitle } from "@app/shared/widget";
import { useNetworkCount } from "@app/compliance-connect/regulator/hooks/useNetworkCount";

const ComplianceConnectTotalWidget: FC = () => {
    const { networkCount, networkCountError, isLoading: loading } = useNetworkCount();

    const renderContent = () => {
        if (loading) return <LoadingSpinner />;
        if (networkCountError) return <QESAlert type="danger" persist>{getGenericErrorMessage()}</QESAlert>;
        return (
            <>
                <p data-testid="compliance-connect-total-count" className="header-m mb-0 mt-2" style={{ fontWeight: "bold", lineHeight: 1 }}>{networkCount?.toLocaleString()}</p>
                <p data-testid="compliance-connect-total-label" className="copy-text-l my-0">Networks</p>
            </>
        );
    };

    return (
        <QESWidget className="compliance-connect-stat-widget">
            <QESWidgetHeader>
                <QESWidgetTitle>TOTAL</QESWidgetTitle>
            </QESWidgetHeader>
            <QESWidgetContent>
                {renderContent()}
            </QESWidgetContent>
        </QESWidget>
    );
};

export default ComplianceConnectTotalWidget;
